import { chipClasses } from '@mui/material';
import { alpha } from '@mui/system';
import { Clear } from '@ori-ui/icons';
import { colors } from '../constants';
import { oriGrey } from '../constants/colors';
import shape from '../shape';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  root: ({
    theme,
    ownerState
  }) => ({
    fontWeight: 'bold',
    fontSize: '1.2rem',
    borderRadius: shape.borderRadius,
    paddingTop: 5,
    paddingBottom: 5,
    lineHeight: '1',
    textTransform: 'uppercase',
    height: 28,
    ...(ownerState.variant === 'outlined' && ownerState.color === 'default' && {
      color: colors.blueGreyBackground[300],
      [`& .${chipClasses.deleteIcon}`]: {
        color: colors.blueGreyBackground[300]
      },
      [`& .${chipClasses.deleteIcon}:hover`]: {
        color: colors.blueGreyBackground[100]
      }
    }),
    ...(ownerState.variant === 'tag' && {
      height: 25,
      fontSize: '1rem',
      [`&.${chipClasses.sizeMedium}`]: {
        height: 25,
        fontSize: '1rem'
      }
    }),
    ...(ownerState.variant === 'tag' && ownerState.color && ownerState.color !== 'default' && {
      color: colors[ownerState.color].dark,
      background: alpha(colors[ownerState.color].main, 0.1),
      [`& .${chipClasses.deleteIcon}`]: {
        color: colors[ownerState.color].dark,
        fontSize: '1.6rem'
      },
      [`& .${chipClasses.deleteIcon}:hover`]: {
        color: colors[ownerState.color].main
      }
    }),
    ...(ownerState.variant === 'tag' && ownerState.color === 'default' && {
      color: colors.defaultColors.main,
      background: alpha(colors.defaultColors.light, 0.1),
      [`& .${chipClasses.deleteIcon}`]: {
        color: colors.defaultColors.main,
        fontSize: '1.6rem'
      },
      [`& .${chipClasses.deleteIcon}:hover`]: {
        color: colors.defaultColors.light
      }
    }),
    ...(ownerState.variant === 'filled' && ownerState.color === 'default' && {
      backgroundColor: colors.blueGreyBackground[300],
      color: colors.commonColors.white,
      [`& .${chipClasses.deleteIcon}`]: {
        color: colors.commonColors.white
      },
      [`& .${chipClasses.deleteIcon}:hover`]: {
        color: oriGrey[200]
      }
    }),
    ...(ownerState.variant === 'rounded' && {
      borderRadius: 999,
      backgroundColor: oriGrey[100],
      height: 32,
      paddingLeft: 5,
      paddingRight: 5,
      color: colors.defaultColors.main,
      [`&.${chipClasses.deletable}`]: {
        paddingRight: 0
      },
      [`& .${chipClasses.deleteIcon}`]: {
        fontSize: '2.2rem',
        color: colors.defaultColors.main
      },
      [`& .${chipClasses.deleteIcon}:hover`]: {
        color: colors.defaultColors.light
      }
    })
  }),
  sizeMedium: {
    fontSize: '1.4rem',
    height: 31
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 10,
    paddingRight: 10
  },
  labelSmall: {
    height: 18
  },
  labelMedium: {
    height: 21
  },
  outlined: {
    borderColor: 'currentColor',
    borderWidth: 1,
    backgroundColor: 'unset'
  }
};
const defaultProps = {
  size: 'small',
  deleteIcon: /*#__PURE__*/_jsx(Clear, {
    fontSize: "inherit"
  })
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiChip.js.map